import { GlobalStore } from "@roc/client-portal-shared/stores";
import { ScopeOfWorkV2Store } from "@roc/feature-sow-shared/stores/v2";
import { CALLBACK_TYPE } from "@roc/feature-sow-shared/constants/scopeOfWorkV2Form";
import { isSecureLinkError } from "@roc-capital/secure-link";
import { flow, makeObservable } from "mobx";
import { ScopeOfWorkRevisionService, SecureLinkRequest, SecureLinkScopeOfWorkRevisionService } from "../services";
import { ScopeOfWorkRevisionFormStore } from "./scopeOfWorkRevisionFormStore";

const noSession: SecureLinkRequest = () =>
  Promise.reject(new Error('ScopeOfWorkRevisionStore: call setRequest() with the session request first'));

/**
 * The scope of work revision page (/link/scope-of-work-revision). Every call goes to loan-service's session-guarded
 * endpoints; the revision draw comes from the secure link session on the server, never from the URL.
 *
 * Created with the app's root store, before there is a session: the page passes the session's request in with
 * setRequest() once useSecureLinkSession has one. Until then every call rejects.
 */
export class ScopeOfWorkRevisionStore extends ScopeOfWorkV2Store {
  protected scopeOfWorkService: ScopeOfWorkRevisionService;
  private secureLinkService: SecureLinkScopeOfWorkRevisionService;
  private revisionFormStore: ScopeOfWorkRevisionFormStore;

  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.scopeOfWorkService = new ScopeOfWorkRevisionService();
    super.scopeOfWorkService = this.scopeOfWorkService;
    this.revisionFormStore = new ScopeOfWorkRevisionFormStore(globalStore);
    this.scopeOfWorkV2FormStore = this.revisionFormStore;
    this.setRequest(noSession);
    makeObservable(this, {
      fetchSOWRevision: flow,
    })
  }

  /** The authorized fetch from useSecureLinkSession; every revision call goes through it. */
  setRequest(request: SecureLinkRequest) {
    this.secureLinkService = new SecureLinkScopeOfWorkRevisionService(request);
    this.revisionFormStore.setSecureLinkService(this.secureLinkService);
  }

  *fetchSOWRevision() {
    try {
      const sowRevision = yield this.secureLinkService.getData();
      const scopeOfWork = JSON.parse(sowRevision.dataContent);
      const params = {
        scopeOfWorkId: scopeOfWork.scopeOfWorkId,
        isInternal: false,
        version: scopeOfWork.version,
        isRevisionSOW: true,
      };
      this.revisionFormStore.setParams(params);
    } catch (error) {
      if (isSecureLinkError(error) && error.kind === 'INVALID') {
        // The page switches to "session ended"; no toast needed.
        return;
      }
      console.log({ error });
      this.revisionFormStore.afterCall(CALLBACK_TYPE.GET, null);
    }
  }
}
